module.exports = __webpack_public_path__ + "img/people-09.098658fa.png";